{
    "Profile_SecureMyOffer_SellerAgreement.header": "Seller agreement",
    "Profile_SecureMyOffer_SellerAgreement.agreed": "The seller agreed to the application",
    "Profile_SecureMyOffer_SellerAgreement.agreedOn": "Agreed on",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail": "Agree email sent",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmailSentOn": "Sent on",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.confirmAndPay": "Confirm and pay",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.paidSeparately": "Agree, paid separately",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.alreadyPaid": "Agree, already paid",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.unknown": "{code}",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.none": "None yet"
}
